import { Directive, inject, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { PriceVisibilityService } from './price-visibility.service';

@Directive({
  selector: '[uiPriceVisibility]',
})
export class PriceVisibilityDirective implements OnInit {
  private readonly templateRef: TemplateRef<unknown> = inject(TemplateRef);
  private readonly viewContainerRef: ViewContainerRef = inject(ViewContainerRef);
  private readonly priceVisibilityService: PriceVisibilityService = inject(PriceVisibilityService);

  public ngOnInit(): void {
    if (!this.priceVisibilityService.canSeePrices()) {
      return;
    }

    this.viewContainerRef.createEmbeddedView(this.templateRef);
  }
}
